<script setup lang="ts">
import { IAuftrag } from "../api/useDispositionsplan";
import { getFahrzeugColor } from "../utils/colors";

defineProps<{
  fahrzeug: Omit<IAuftrag["fahrzeug"], "fahrer_namen" | "fahrer">;
  abrechnungsnummer?: string;
}>();
</script>

<template>
  <div
    v-if="
      fahrzeug.fahrzeugtyp || fahrzeug.fahrgestellnummer || abrechnungsnummer
    "
  >
    <hr class="h-px bg-gray-300 border-0" />
    <div class="flex divide-x divide-gray-300">
      <div class="py-0.5 pr-0.5 text-sm w-full">
        <div :class="getFahrzeugColor(fahrzeug.fahrzeugtyp)" class="pl-0.5">
          <span v-if="fahrzeug.fahrzeugtyp">
            {{ fahrzeug.fahrzeugtyp + ": " }}
          </span>
          <span v-if="fahrzeug.fahrgestellnummer">
            {{ fahrzeug.fahrgestellnummer || "-" }}
          </span>
        </div>
      </div>
      <div v-if="abrechnungsnummer" class="text-sm text-right py-0.5 px-0.5">
        {{ abrechnungsnummer }}
      </div>
    </div>
  </div>
</template>
